module.exports = __webpack_public_path__ + "img/P150T_weapon_105.2b414e83.png";